module.exports = __webpack_public_path__ + "static/img/QYM.c6c219e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/other/QYM/QYM.png
// module id = wnX+
// module chunks = 0